module.exports = __webpack_public_path__ + "static/media/logo-header.8f8c7c03.svg";